// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback-menu-item__text-area-input{height:200px !important}`, "",{"version":3,"sources":["webpack://./app/new-components/HelpMenu/components/FeedbackMenuItem/FeedbackMenuItem.scss"],"names":[],"mappings":"AACE,qCACE,uBAAA","sourcesContent":[".feedback-menu-item {\n  &__text-area-input {\n    height: 200px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
